import { useMtmColumnStore } from '@/stores/trades/mtm-column-store';
import { createCrossDndProvider, stripSidebarPrefix, addSidebarPrefix } from '@/components/shared/createCrossDndProvider';
import type { CreateCrossDndProviderConfig } from '@/components/shared/createCrossDndProvider';

// eslint-disable-next-line react-refresh/only-export-components -- re-exporting utility helpers alongside the Provider; splitting would require updating multiple import sites
export { stripSidebarPrefix, addSidebarPrefix };

const { Provider, useCrossDnd } = createCrossDndProvider({
  useColumnStore: useMtmColumnStore as CreateCrossDndProviderConfig['useColumnStore'],
  tableScrollSelector: '[data-mtm-table-scroll-container]',
  displayName: 'MtmCrossDndProvider',
});

export const MtmCrossDndProvider = Provider;
// eslint-disable-next-line react-refresh/only-export-components -- hook paired by design with the Provider above
export const useMtmCrossDnd = useCrossDnd;
